// extracted by mini-css-extract-plugin
export default {"modal":"FileBrowserModal-modal-XB8yQ Modal-modal-_3qBG"};